import React from 'react';
import { Container, Graphics } from '@pixi/react';

function BlackLayer() {
  return (
    <Container>
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill('black');
          g.drawRect(0, 0, window.innerWidth, window.innerHeight);
          g.alpha = 0.7;
          g.interactive = true;
        }}
      />
    </Container>
  );
}
export default BlackLayer;
